import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {DashboardComponent} from './dashboard/dashboard.component';
import {LoginComponent} from './login/login.component';
import {AuthGuardService} from '../core/services/guard/auth-guard.service';
import {AdminLayoutComponent} from '../theme/admin-layout/admin-layout.component';
import {AuthLayoutComponent} from '../theme/auth-layout/auth-layout.component';
import {USERS_ROLES} from '../core/services/user.service';
import {RegisterComponent} from './register/register.component';
import {UserGuardService} from '../core/services/guard/user-guard.service';
import {PageNotFoundComponent} from './error/page-not-found/page-not-found.component';
import {StatisticsComponent} from './statistics/statistics.component';
import {AgentsComponent} from './agents/agents.component';
import {DevelopersComponent} from './developers/developers.component';
import {EmailComponent} from '../shared/components/email/email.component';
import {BlackRedirectGuard} from '../core/services/guard/black-redirect.guard';

/**
 * @class RoutesRoutingModule
 * @memberOf RoutesModule
 * @description This is a module which config route path of the system
 */
const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'projects',
        loadChildren: () => import('./project/project.module').then(m => m.ProjectModule)
      },
      {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          title: 'Dashboard',
          titleI18n: 'dashboard',
          roles: [USERS_ROLES.DEV_ADMIN]
        },
      },
      {
        path: 'staff',
        loadChildren: () => import('./staff/staff.module').then(m => m.StaffModule),
        data: {
          roles: [USERS_ROLES.DEV_ADMIN]
        },
        canActivate: [UserGuardService]
      },
      {
        path: 'profile',
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule)
      },
      {
        path: 'notification',
        loadChildren: () => import('./notification/notification.module').then(m => m.NotificationModule)
      },
      {
        path: 'statistics',
        component: StatisticsComponent,
      }
    ],
    data: {
      roles: [USERS_ROLES.DEV_ADMIN, USERS_ROLES.DEV_MANAGER, USERS_ROLES.DEV_EMPLOYEE]
    },
    canActivate: [AuthGuardService]
  },
  {
    path: 'auth',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'home',
        component: DevelopersComponent,
      },
      {
        path: 'goVr',
        component: DevelopersComponent,
      },
      {
        path: 'goAgentPortal',
        component: DevelopersComponent,
      },
      {
        path: 'goAr',
        component: DevelopersComponent,
      },
      {
        path: 'go3D',
        component: DevelopersComponent,
      },
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'register',
        component: RegisterComponent
      },
      {
        path: 'agents',
        component: AgentsComponent
      },
      {
        path: 'developers',
        component: DevelopersComponent
      },
    ]
  },
  {
    path: 'email',
    component: EmailComponent,
  },
  {
    path: 'black',
    canActivate: [BlackRedirectGuard],
    children: [{ path: '**', children: [] }]
  },
  {
    path: 'page-not-found', component: PageNotFoundComponent
  },
  {path: '**', redirectTo: 'page-not-found'},
];


@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    useHash: false,
    onSameUrlNavigation: 'reload',
    anchorScrolling: 'enabled',
  })],
  exports: [RouterModule]

})
export class RoutesRoutingModule {
}
